import React from 'react';

import addToCanvas from 'styles/assets/svg/addToCanvas.svg';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';

import classes from './NoConfigurationEmptyState.module.scss';

interface Props {
    setIsConfigureDrawerOpen: (isOpen: boolean) => void;
}

const TITLE = 'Configure your view';
const SUBTITLE = 'Add rows, select activities, and drag to reorder. Configure how each row groups and presents data.';

export const NoConfigurationEmptyState = ({ setIsConfigureDrawerOpen }: Props) => {
    return (
        <div className={classes.NoConfigurationEmptyState}>
            <div className={classes.emptyState}>
                <img src={addToCanvas} className={classes.emptyStateImage} alt={'empty state image'} />
                <div className={classes.emptyStateTitle}>{TITLE}</div>
                <div className={classes.emptyStateSubTitle}>{SUBTITLE}</div>
                <div className={classes.buttonWrapper}>
                    <Button
                        onClick={() => setIsConfigureDrawerOpen(true)}
                        startIcon={<MuiIcon icon={'tune'} color={'inherit'} />}
                        data-testid={'configure-view-btn'}
                    >
                        Configure view
                    </Button>
                </div>
            </div>
        </div>
    );
};
